<template>
  <AIVDialog v-model="visible" title="Acknowledge CST" width="80%" height="85vh">
    <div v-if="cst">
      <!-- CST Content (read-only) -->
      <CstViewModal :cst="cst" :value="false" style="display:contents" />

      <!-- Signature Section -->
      <div class="ack-signature">
        <h6>Sign to Acknowledge</h6>
        <p class="ack-signature__note">
          By signing below, I acknowledge that I have read and understand the Client Summary of Training
          for {{ cst.client_first_name }} {{ cst.client_last_name }} (version {{ cst.version }}).
        </p>
        <div class="ack-signature__canvas-wrapper">
          <canvas ref="ackCanvas" class="ack-signature__canvas"></canvas>
        </div>
        <div class="ack-signature__actions">
          <el-button size="small" @click="clearSignature">Clear</el-button>
        </div>
      </div>
    </div>

    <template slot="footer">
      <div class="text-center">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" @click="submitAcknowledgment" :loading="submitting">
          <i class="fa fa-check"></i> Acknowledge
        </el-button>
      </div>
    </template>
  </AIVDialog>
</template>

<script>
import { cstService } from "@/serviceHandlers/cstService";

export default {
  name: "CstAcknowledgeModal",
  props: {
    value: { type: Boolean, default: false },
    cst: { type: Object, default: null },
  },
  data() {
    return {
      signaturePad: null,
      submitting: false,
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.$nextTick(() => this.initSignaturePad());
      }
    },
  },
  methods: {
    async initSignaturePad() {
      try {
        const SignaturePad = (await import("signature_pad")).default;
        const canvas = this.$refs.ackCanvas;
        if (canvas) {
          canvas.width = canvas.parentElement.clientWidth;
          canvas.height = 150;
          this.signaturePad = new SignaturePad(canvas, {
            backgroundColor: "rgb(255, 255, 255)",
            penColor: "rgb(0, 0, 0)",
          });
        }
      } catch (err) {
      }
    },
    clearSignature() {
      if (this.signaturePad) this.signaturePad.clear();
    },
    async submitAcknowledgment() {
      if (!this.signaturePad || this.signaturePad.isEmpty()) {
        this.$notifyError("Please provide your signature.");
        return;
      }

      this.submitting = true;
      try {
        const signatureImage = this.signaturePad.toDataURL("image/png");
        await cstService.acknowledge(this.cst.id, signatureImage);
        this.$notifySuccess("CST acknowledged successfully!");
        this.$emit("acknowledged");
        this.visible = false;
      } catch (error) {
        this.$notifyError(error.response?.data?.message || "Error acknowledging CST.");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.ack-signature { margin-top: 1.5rem; padding-top: 1rem; border-top: 1px solid rgba(255, 255, 255, 0.1); }
.ack-signature h6 { color: #fff; margin-bottom: 0.5rem; }
.ack-signature__note { color: #b3a6a6; font-size: 0.9rem; margin-bottom: 1rem; }
.ack-signature__canvas-wrapper { border: 2px solid #447DF7; border-radius: 6px; overflow: hidden; background: #fff; }
.ack-signature__canvas { display: block; width: 100%; cursor: crosshair; }
.ack-signature__actions { margin-top: 0.5rem; }
</style>
